import { useImportJobStatus } from "hooks/useImportJobStatus";
import { useTranslation } from "react-i18next";

const ProgressToast = ({ jobId }: { jobId: number }) => {
    const [t] = useTranslation();

    const { progress } = useImportJobStatus({
        jobId,
    });

    const progressText = `${progress || 0}%`;

    return <div className="text-sm">{progressText}</div>;
};

export default ProgressToast;
